module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS6.e745f6ce.jpg";